import SignIn from '../../components/Auth/SignIn';
import './styles.scss';

const LogIn = (props: any) => {
  return <SignIn />
}

export default LogIn;